import { useRef } from 'react';

import FORM_KEYS from 'apps/web/constants/forms/generic-unpacking/formKeys';
import { GENERIC_UNPACKING_ITEM_CHAR_LIMIT } from 'apps/web/constants/genericUnpacking';
import useAutosizeTextArea from 'apps/web/hooks/useAutoSizeTextArea';
import { useScrollToError } from 'apps/web/hooks/useScrollToError';
import processInput from 'apps/web/utils/formInput';

import { LP_PAGE_SUBJECT_CHAR_LIMIT } from '@lessonPlanner/constants';

import { TextAreaField, TextField } from '../form-fields';
import { GradeLevelDropdown } from '../Select';

export default function GenericUnpackingLP({
  errors,
  watchedValues,
  triggerValidation,
  setValue,
}: {
  errors: any;
  watchedValues: any;
  triggerValidation: any;
  setValue: any;
}) {
  async function updateFieldValue(fieldName: string, value: string) {
    setValue(fieldName, value);
  }

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  useAutosizeTextArea(textAreaRef.current, watchedValues.itemToUnpack);

  useScrollToError(errors);

  return (
    <>
      <TextField
        className="col-span-full"
        errorMessage={!!errors.subject && 'Please enter the Subject'}
        id="subject"
        label="Subject"
        maxLength={LP_PAGE_SUBJECT_CHAR_LIMIT}
        name="subject"
        placeholder="Input the subject"
        type="subject"
        value={watchedValues.subject}
        isMaxLengthReached={
          watchedValues.subject?.length >= LP_PAGE_SUBJECT_CHAR_LIMIT
        }
        onBlur={() => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.subject,
            watchedValues.subject?.trim() || '',
          );
        }}
        onChange={(e) => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.subject,
            e.target.value,
          );
        }}
      />

      <GradeLevelDropdown
        hasCollege
        error={errors.gradeLevel}
        errorMessage={!!errors.gradeLevel && 'Please select the Grade Level'}
        label="Grade Level"
        value={watchedValues.gradeLevel}
        onChange={(value) => updateFieldValue(FORM_KEYS.gradeLevel, value)}
        onBlur={() => {
          triggerValidation(FORM_KEYS.gradeLevel);
        }}
      />

      <TextAreaField
        showSubLabel
        className="col-span-full"
        error={!!errors.itemToUnpack}
        id="itemToUnpack"
        label="Learning Competency"
        link="https://www.deped.gov.ph/matatagcurriculumk147/"
        maxLength={GENERIC_UNPACKING_ITEM_CHAR_LIMIT}
        name="itemToUnpack"
        placeholder="Input the learning competency to be unpacked"
        rows={4}
        subLabel="Add the main learning competency to be unpacked into 5 LC's"
        textAreaRef={textAreaRef}
        value={watchedValues.itemToUnpack}
        errorMessage={
          !!errors.itemToUnpack && 'Please enter the Learning Competency'
        }
        isMaxLengthReached={
          watchedValues.itemToUnpack?.length >=
          GENERIC_UNPACKING_ITEM_CHAR_LIMIT
        }
        onBlur={() => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.itemToUnpack,
            watchedValues.itemToUnpack?.trim() || '',
          );
        }}
        onChange={(e) => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.itemToUnpack,
            e.target.value,
          );
        }}
      />
    </>
  );
}
